import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
//import './timeslotcalendar.scss';
import _ from 'lodash';
import moment from 'moment';
import TimeSlotRow from './TimeSlotRow/TimeSlotRow.jsx';
import TimeSlotRowHeader from './TimeSlotRowHeader/TimeSlotRowHeader.jsx';

class TimeSlotCalendar extends Component {

  shouldComponentUpdate(nextProps) {
    return !_.isEqual(this.props, nextProps) || this.startDate === '' || this.startDay === '' || this.endDay === '';
  }

  startDate = '';
  startDay = '';
  endDay = '';
  page = -1;
  step = 5;
  numDays = 0; // max number of days to show

  // 1. gets an array of unique timeslots (time only)
  // 2. adds utility properties to all time slots
  // 3. groups all time slots by time slot
  // 4. iterates over 28 days from the first timeSlot adding a day for each time slot
  //    and appends this array of days to the unique time slots
  // 5. ends up with an array of objects. one for unique timestamp which is a row in the cal
  // 6. inside these time objects is an array of 28 days which contain the time slot for that day
  // 7. the time slot for each day is all calculated relatively by the server response, no local dates are done
  //    all time and date compuation are done based on server response but not relative to now (client)
  // 8. a time slot has a boolean 'available' field designating availability. if no time slot is found in response
  //    there will still be a slot but it wont have "availability"
  // THIS SHOULD BE MODERATELY BULLETPROOF
  // NOTE: time stamps are sorted by startTime first, then if startTime matches it will sort by endTime

  buildBetterTimeSlots(timeSlots) {
      const betterTimeSlots = timeSlots.map((timeSlot) => {
        const time = this.formatTimeSlot(timeSlot);

        return {
          ...timeSlot,
          ...time
        };
      });

      return betterTimeSlots;
    }

    buildTimeSlotsUnique(timeSlotsOnly) {
      const timeSlotsUnique = timeSlotsOnly.map((timeSlot) => {
        return {
          ...timeSlot,
          days: []
        };
      });

      return timeSlotsUnique;
    }

    getSelectedPage(timeSlots, selectedTimeSlotObj) {
      if (!timeSlots || !selectedTimeSlotObj) {
        return 0;
      }

      const sorted = this.sortTimeSlotsByDate(timeSlots);

      if (!sorted.length) {
        return 0;
      }
      const momentStartDay = moment(sorted[0].days[0].startDateTime);
      const momentSelectedDay = moment(selectedTimeSlotObj.startDateTime);
      const numDays=Math.abs(momentStartDay.diff(momentSelectedDay, 'days'))+1;
      const selectedPage = Math.ceil(numDays/5) - 1;

      return selectedPage;

    }

    getNumDays(timeSlots) {
      if (!timeSlots) {
        return;
      }
      const sorted = this.sortTimeSlotsByDate(timeSlots);

      if (!sorted.length) {
        return;
      }
      const startDay = _.head(sorted);
      const endDay = _.last(sorted);

      const momentStartDay = moment(startDay.startDateTime);
      const momentEndDay = moment(endDay.endDateTime);

      // gets absolute value of difference in days
      const numDays=Math.abs(momentStartDay.diff(momentEndDay, 'days'))+1;

      this.numDays = numDays;

      return numDays;
    }

    formatTimeSlot(timeSlot) {
      const momentStart = moment(timeSlot.startDateTime);
      const momentEnd = moment(timeSlot.endDateTime);

      // TODO FORMAT TIME AS TO UX STANDARDS
      // Z times are 24 hour HHmm for sorting
      const startTimeZ = momentStart.format('HHmm');
      const endTimeZ = momentEnd.format('HHmm');

      const dateString = momentEnd.format('YYYYMMDD');

      // UX startTime and endTime
      const startTime = momentStart.format('h:mmA');
      const endTime = momentEnd.format('h:mmA');

      // string of formatted time
      const time = `${startTime} - ${endTime}`;

      return {startTime: startTime, endTime: endTime, startTimeZ: startTimeZ, endTimeZ: endTimeZ, formatted: time, dateString: dateString};
    }

    // used to get unique time slots, returns true if same time range
    testTime(timeSlotA, timeSlotB) {
      return timeSlotA.formatted === timeSlotB.formatted;
    }

    // build an array of unique timeslots formatted accordingly
    getTimeSlotsOnly(timeSlots) {
      if (!timeSlots || !timeSlots.length) {
        return;
      }
      // build time slots without dates (however it has a date string)
      const justTimeSlots = timeSlots.map( (timeSlot) => {
        return this.formatTimeSlot(timeSlot);
      });

      // get unique timeslots
      const unique = _.uniqWith(justTimeSlots, this.testTime); // we need a custom compare method now because of dateString
      //const unique = _.uniqWith(justTimeSlots, _.isEqual); // not used because datestring is unique

      const sorted = unique.sort(function(a, b) {
        // check if startTime is the same, if so sort by endTime
        if (a.startTimeZ === b.startTimeZ) {
          return a.endTimeZ - b.endTimeZ;
        } else {
          return a.startTimeZ - b.startTimeZ;
        }
      });

      return sorted;
    }

    // finds the time slot in a list of timeSlots
    findTimeSlot(timeSlots, timeRange, dateString) {
      const ts = _.find(timeSlots, {'formatted': timeRange, 'dateString': dateString});

      return ts;
    }

    sortTimeSlotsByDate = _.memoize(function (timeSlots) {
      const sorted = [...timeSlots].sort(function (a, b) {
        // check if start time is the same, if so sort by endTime
        if (a.startDateTime !== b.startDateTime) {
          return (a.startDateTime || "").toLocaleLowerCase().localeCompare((b.startDateTime || "").toLocaleLowerCase());
        } else {
          return (a.endDateTime || "").toLocaleLowerCase().localeCompare((b.endDateTime || "").toLocaleLowerCase());
        }
      });

      return sorted;
    });

    fillDays(timeSlots, timeSlotsUnique, numDays) {
      if (!timeSlots || !timeSlotsUnique) {
        return;
      }

      // sort time sortTimeStamps so we know which day to start on
      const sorted = this.sortTimeSlotsByDate(timeSlots);

      if (!sorted.length) {
        return;
      }
      const startDay = moment(sorted[0].startDateTime); // this can only fail if there are no dates

      this.startDate = moment(sorted[0].startDateTime).format('YYYYMMDD');

      const timeSlotsFilled = timeSlotsUnique.map((timeSlot) => {

        // TODO: GET MAX DAYS FROM BACKEND (configurable)
        for (let i=0;i<=numDays;i++) {
          let newDate = moment(startDay, "YYYYMMDD").add(i, 'days'); // add up to 28 days to first day
          const newDateString = newDate.format('YYYYMMDD'); // format to match our date string
          // this will find a time slot with a time range and a dateString
          // if we dont find one we add an empty time range with available = false
          const ts = this.findTimeSlot(timeSlots, timeSlot.formatted, newDateString);

          if (ts) {
            timeSlot.days.push({
              ...ts,
              available: true
            });
          } else {
            timeSlot.days.push({
              formatted: timeSlot.formatted,
              dateString: newDateString,
              available: false
            });
          }
        }
        return timeSlot;

      });

      return timeSlotsFilled;
    }

    // TODO: this will need optimization not to duplicate all data calc
    // this has a problem with days out of range
    updateDays(fillDays) {
      if (!fillDays) {
        return;
      }

      // TODO: this logic should be done at the global level and then passed down
      // this is required for the row and header (startDay & endDay)
      let start = 0+this.step*this.page;
      let end = 0+(this.step*(this.page+1))-1;

      while (end >= this.numDays) {
        end--;
        start--;
      }
      const startDay = fillDays[0].days[start];
      const endDay = fillDays[0].days[end];

      // it should not reach here but just in case lets not render a day out of bounds
      if (!startDay || !endDay) {
        return;
      }

      this.startDay = moment(startDay.dateString).format('MMM DD, YYYY');
      this.endDay = moment(endDay.dateString).format('MMM DD, YYYY');

      return `${this.startDay} - ${this.endDay}`;
    }

    timeSlotFunc(timeSlots) {

      if (!timeSlots || !timeSlots.length) {
        return;
      }
      // get unique time slot

      let numDays = this.getNumDays(timeSlots);

      if (numDays < 5) {
        numDays = 5;
        this.numDays = numDays;
      }

      const timeSlotsOnly = this.getTimeSlotsOnly(timeSlots);

      // get unique time slots with empty day array
      const timeSlotsUnique = this.buildTimeSlotsUnique(timeSlotsOnly);

      // time slots with startTime, endTime, startTimeZ, endTimeZ, formatted, day
      const betterTimeSlots = this.buildBetterTimeSlots(timeSlots);

      // time slots with 28 days full
      const fillDays = this.fillDays(betterTimeSlots, timeSlotsUnique, numDays);

      return fillDays;

    }

    // TODO: forceUpdate is not deal. Find a better way to do this
    handleBack() {
      if (this.page>0) {
        this.page--;
      }
      this.forceUpdate();

    }

    // TODO: forceUpdate is not deal. Find a better way to do this
    handleForward() {
      if (this.page<=5) {
        this.page++;
      }
      this.forceUpdate();
    }

    backDisabled() {
      if (this.page<=0) return true;
    }

    forwardDisabled() {
      const numPages = Math.ceil(this.numDays/5);

      if (this.page>=(numPages-1)) return true;
    }

    // renders time slots unique array
    renderTimeSlots(timeSlots) {
      if (!timeSlots) return;
      if (this.page < 0) {
        this.page = this.getSelectedPage((timeSlots), this.props.selectedTimeSlotObj);
      }

      return (
        <div className="">
          <table>
            <tbody>
              <TimeSlotRowHeader days={timeSlots[0].days} startDate={this.startDate} page={this.page} numDaysShow={this.step} numDays={this.numDays} />
              {timeSlots.map( (timeSlot, i) =>
                <TimeSlotRow 
                  days={timeSlot.days}
                  startDate={this.startDate}
                  page={this.page}
                  numDaysShow={this.step}
                  numDays={this.numDays}
                  key={i}
                  setSelectedTimeSlot={this.props.setSelectedTimeSlot}
                  selectedTimeSlot={this.props.selectedTimeSlot}
                />
              )}
            </tbody>
          </table>

        </div>
      );
    }

  render() {
    const classes = 'hg-timeSlotCalendar hidden-sm-down';

    const {
      children,
      className,
      timeSlots
    } = this.props;

    // conditionally enable or disable back and forward on the cal
    const backClickable = (!this.backDisabled()) ? this.handleBack.bind(this) : null;
    const forwardClickable = (!this.forwardDisabled()) ? this.handleForward.bind(this) : null;

    return (
      // TODO: fix update days not to use timeSlotFunc because it's expensive
      <div {...this.props} className={classNames(className, classes)}>
        <div className="s-install--head">
           <button data-tracking={{}} type="button" className={classNames('s-install--arrow', 's-install--arrow-left', {disabled: this.backDisabled() })} disabled={this.backDisabled()} onClick={backClickable}>
             <span className="vh">Previous</span>
           </button>
           <div className="s-install--date-range x-heading3">{this.updateDays(this.timeSlotFunc(timeSlots))}</div>
           <button data-tracking={{}} type="button" className={classNames('s-install--arrow', 's-install--arrow-right', {disabled: this.forwardDisabled() })} disabled={this.forwardDisabled()} onClick={forwardClickable}>
             <span className="vh">Next</span>
           </button>
       </div>
        {this.renderTimeSlots(this.timeSlotFunc(timeSlots))}
        {children}
      </div>
    );
  }
}

TimeSlotCalendar.propTypes = {
    children: PropTypes.node,
    timeSlots: PropTypes.array,
    selectedTimeSlotObj: PropTypes.object,
    setSelectedTimeSlot: PropTypes.func,
    selectedTimeSlot: PropTypes.string,
    className: PropTypes.string
};

export default TimeSlotCalendar;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/TimeSlotCalendar/src/TimeSlotCalendar.jsx
 **/